module.exports = __webpack_public_path__ + "media/images/classpoints/classpoints-hero_stride-26b2978ae773e14e3f53653045afa0a2.png";